/* ニャクア カートドロワー
   本家(KittySpout)の作りに合わせて、品目は /cart.js から描く。
   触るのは #CartDrawer の中だけ。テーマ本体のドロワーは使わない。 */
(function () {
  var D, OV, ITEMS, EMPTY, UPS, UPSL, SUBL, SUBP, DCI, DCB, DCM;
  /* 2026-09-06：本体が2種類になった（1台／2台セット） */
  var FOUNTAIN  = 53467524202805;      /* 本体 1台      ¥12,000 */
  var FOUNTAIN2 = 53467524104501;      /* 本体 2台セット ¥19,200 */
  /* 2026-09-10：犬用（ワクア）を追加（Eugene指示）。
     🔴 ここに入れんと、犬を買った人は「送料無料」の枠もフィルターの勧めも
        まるごと出んかった（猫の商品番号でしか動かんかったため）。 */
  var FOUNTAIN_DOG = 53519354921269;   /* ワクア 犬用 1台 ¥15,000 */
  /* 2026-09-12：3台セットを追加（Eugene指示）。
     🔴 ここに入れんと、3台を買った人に「無料特典」と書いといて何も入らん。
        9/11に犬で起きた事故と同じ形なので、作った日に同時に足した。 */
  var FOUNTAIN3 = 53546706534709;      /* 本体 3台セット ¥23,400 */
  var FOUNTAINS = [FOUNTAIN, FOUNTAIN2, FOUNTAIN3, FOUNTAIN_DOG];
  var FILTERS  = [53444529357109, 53444529717557, 53444529750325];
  var UPSELL_FILTER = 53444529717557;      // 3枚セット ¥4,980
  var BRUSH_SINGLE = 53460693745973;       // おそうじブラシ 単品 ¥1,980
  var BRUSH_WITH   = 53460693778741;       // おそうじブラシ 本体と同時 ¥980
  /* 2026-09-11：ブラシにも「無料ギフト ¥0」の variant を用意した（Eugene指示）。
     🔴 前は店の自動割引「本体購入でおそうじブラシセット無料」で¥0にしとった。
        その割引の買う側は【猫の2台セットだけ】。犬（ワクア）は対象外なので、
        犬の客にブラシを入れると ¥1,980 が請求される所やった。
        グローブと同じ¥0 variant 方式にして、割引に一切依存させん。 */
  var BRUSH_GIFT   = 53531180400949;       // おそうじブラシ 無料ギフト ¥0（猫）
  /* 2026-09-11：犬の客の注文明細に「ニャクア 猫用…」と出るのを直す（Eugene指示）。
     物は同じでも、犬を買うた人の明細・納品書に「猫用」と出るのは気持ち悪い。
     猫の商品名を変えると今度は猫の客が犬になるので、犬用の商品を別に作った。 */
  var DOG_BRUSH_GIFT = 53531297022261;     // ワクア 犬用給水器 おそうじブラシセット 無料ギフト ¥0
  var DOG_GLOVE_GIFT = 53531296989493;     // ワクア 犬用 毛取りグローブ 無料ギフト ¥0
  var BRUSHES = [BRUSH_SINGLE, BRUSH_WITH, BRUSH_GIFT, DOG_BRUSH_GIFT];
  /* 2026-09-09 毛取りグローブ（Eugene指示）
     🔴 ブラシと違って「無料ギフト用に ¥0 のバリエーション」を用意した。
        店の自動割引に依存せんので、割引が消えても客に¥1,480請求される事故が起きん。 */
  var GLOVE_SINGLE = 53522896093493;       // 毛取りグローブ 単品      ¥1,480
  var GLOVE_WITH   = 53522896847157;       // 毛取りグローブ 本体と同時 ¥980
  var GLOVE_GIFT   = 53522897895733;       // 毛取りグローブ 無料ギフト ¥0
  var GLOVES = [GLOVE_SINGLE, GLOVE_WITH, GLOVE_GIFT, DOG_GLOVE_GIFT];
  var pcache = {};

  function yen(cents) {
    return '¥' + Math.round(cents / 100).toLocaleString('ja-JP');
  }
  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }
  function px(url, size) {
    if (!url) return '';
    return url.replace(/(\.(?:png|jpe?g|webp|gif))(\?|$)/i, '_' + size + 'x$1$2');
  }

  /* ── 押した瞬間に「カートに追加中…」に変える（本家KittySpoutの ADDING... と同じ） ──
     何も変わらん時間が0.5秒でもあると、客は「壊れた」と思ってもう一回押す。
     文言を変えて・押せんようにして・くるくるを出す。 */
  var ADDING = 'カートに追加中…';
  function busyOn(btn) {
    if (!btn || btn.dataset.cdBusy) return;
    var label = btn.querySelector('span') || btn;
    btn.dataset.cdBusy = '1';
    btn.dataset.cdLabel = label.textContent;
    label.textContent = ADDING;
    btn.classList.add('cd-adding');
    btn.setAttribute('aria-busy', 'true');
    btn.disabled = true;
    var sp = btn.querySelector('.loading__spinner');
    if (sp) sp.classList.remove('hidden');
  }
  function busyOff(btn) {
    if (!btn || !btn.dataset.cdBusy) return;
    var label = btn.querySelector('span') || btn;
    label.textContent = btn.dataset.cdLabel || label.textContent;
    btn.classList.remove('cd-adding');
    btn.removeAttribute('aria-busy');
    btn.disabled = false;
    var sp = btn.querySelector('.loading__spinner');
    if (sp) sp.classList.add('hidden');
    delete btn.dataset.cdBusy; delete btn.dataset.cdLabel;
  }
  function findAddBtn(form) {
    return (form && (form.querySelector('[type=submit]') || form.querySelector('button'))) ||
           document.querySelector('form[action*="/cart/add"] [type=submit]');
  }

  /* ── 開け閉め ───────────────────────────── */
  function open() {
    if (!D) return;
    D.classList.add('is-open'); D.setAttribute('aria-hidden', 'false');
    if (OV) OV.classList.add('is-open');
    refresh();
  }
  function close() {
    if (!D) return;
    D.classList.remove('is-open'); D.setAttribute('aria-hidden', 'true');
    if (OV) OV.classList.remove('is-open');
  }

  /* ── 品目を描く ─────────────────────────── */
  function itemHTML(it) {
    var line = yen(it.line_price != null ? it.line_price : it.price * it.quantity);
    /* 無料ギフトの行は、数量いじりも削除もさせん（本体と一緒に付いてくる物なので） */
    if (it.properties && it.properties['_無料ギフト']) {
      return '' +
      '<li class="cd-item cd-item--gift" data-key="' + esc(it.key) + '" data-variant="' + it.variant_id + '">' +
        '<span class="cd-item-thumb" aria-hidden="true">' +
          '<img src="' + esc(px(it.image, 160)) + '" alt="" width="80" height="80" loading="lazy">' +
        '</span>' +
        '<div class="cd-item-info">' +
          '<span class="cd-item-name">' + esc(it.product_title) + '</span>' +
          '<div class="cd-item-meta">本体に付いてくる無料ギフト</div>' +
          '<div class="cd-item-foot">' +
            '<span class="cd-gift-badge">無料ギフト</span>' +
            '<div class="cd-price-block"><span class="cd-p-was">' + yen(it.price) + '</span>' +
            '<span class="cd-p cd-p-free">無料</span></div>' +
          '</div>' +
        '</div>' +
      '</li>';
    }
    var sub = it.variant_title && it.variant_title !== 'Default Title'
      ? '<div class="cd-item-meta">' + esc(it.variant_title) + '</div>' : '';
    var plan = it.selling_plan_allocation
      ? '<div class="cd-item-meta">' + esc(it.selling_plan_allocation.selling_plan.name) + '</div>' : '';
    return '' +
    '<li class="cd-item" data-key="' + esc(it.key) + '" data-variant="' + it.variant_id + '">' +
      '<a href="' + esc(it.url) + '" class="cd-item-thumb" tabindex="-1" aria-hidden="true">' +
        '<img src="' + esc(px(it.image, 160)) + '" alt="' + esc(it.product_title) + '" width="80" height="80" loading="lazy">' +
      '</a>' +
      '<div class="cd-item-info">' +
        '<a href="' + esc(it.url) + '" class="cd-item-name">' + esc(it.product_title) + '</a>' +
        sub + plan +
        '<div class="cd-item-foot">' +
          '<div class="cd-qty-widget">' +
            '<button type="button" class="cd-qbtn" data-qty-change data-key="' + esc(it.key) + '" data-qty="' + (it.quantity - 1) + '" aria-label="' + esc(it.product_title) + ' を1つ減らす">' +
              '<svg width="10" height="2" viewBox="0 0 10 2" fill="none" aria-hidden="true"><path d="M1 1H9" stroke="currentColor" stroke-width="1.8" stroke-linecap="round"></path></svg>' +
            '</button>' +
            '<span class="cd-qty-val" aria-label="数量">' + it.quantity + '</span>' +
            '<button type="button" class="cd-qbtn" data-qty-change data-key="' + esc(it.key) + '" data-qty="' + (it.quantity + 1) + '" aria-label="' + esc(it.product_title) + ' を1つ増やす">' +
              '<svg width="10" height="10" viewBox="0 0 10 10" fill="none" aria-hidden="true"><path d="M5 1V9M1 5H9" stroke="currentColor" stroke-width="1.8" stroke-linecap="round"></path></svg>' +
            '</button>' +
          '</div>' +
          '<div class="cd-price-block"><span class="cd-p">' + line + '</span></div>' +
        '</div>' +
      '</div>' +
      '<button type="button" class="cd-del" data-remove data-key="' + esc(it.key) + '" aria-label="' + esc(it.product_title) + ' をカートから削除">' +
        '<svg width="13" height="15" viewBox="0 0 13 15" fill="none" aria-hidden="true"><path d="M1 3.5H12M4.5 3.5V2H8.5V3.5M2 3.5L2.6 13H10.4L11 3.5" stroke="currentColor" stroke-width="1.3" stroke-linecap="round" stroke-linejoin="round"></path></svg>' +
      '</button>' +
    '</li>';
  }

  function render(cart) {
    if (!ITEMS) return;
    ITEMS.innerHTML = cart.items.map(itemHTML).join('');
    var isEmpty = cart.item_count === 0;
    if (EMPTY) { EMPTY.style.display = isEmpty ? '' : 'none'; EMPTY.setAttribute('aria-hidden', isEmpty ? 'false' : 'true'); }
    ITEMS.setAttribute('aria-hidden', isEmpty ? 'true' : 'false');
    if (SUBL) SUBL.textContent = '小計（' + cart.item_count + '点）';
    if (SUBP) SUBP.textContent = yen(cart.total_price);
    gifts(cart);
    upsell(cart);
    var b = document.querySelector('.cart-count-bubble span, #cart-icon-bubble .cart-count-bubble span');
    if (b) b.textContent = cart.item_count;
  }

  /* ── アップセル（本家と同じ1枠） ───────────── */
  function getProduct(handle) {
    if (pcache[handle]) return Promise.resolve(pcache[handle]);
    return fetch('/products/' + handle + '.js').then(function (r) { return r.json(); })
      .then(function (p) { pcache[handle] = p; return p; });
  }
  function upsell(cart) {
    if (!UPS || !UPSL) return;
    var ids = cart.items.map(function (i) { return i.variant_id; });
    var hasF = FOUNTAINS.some(function (v) { return ids.indexOf(v) >= 0; });
    var hasFilter = ids.some(function (id) { return FILTERS.indexOf(id) >= 0; });
    var list = [];
    if (hasF && !hasFilter) {
      /* 給水器だけ入っとる → フィルターを1箱／2箱の2択で出す（2箱を推す） */
      list.push({ handle: 'cat-fountain-filter', vid: 53444529357109, name: '交換フィルター 1箱', note: 'カートリッジ8個 ＋ コットン4枚', badge: '', img: 'f1' });
      list.push({ handle: 'cat-fountain-filter', vid: 53444529717557, name: '交換フィルター 2箱', note: '1箱あたり ¥3,490', badge: 'おトク', img: 'f2' });
    } else if (hasFilter && !hasF) {
      list.push({ handle: 'cat-water-fountain-2-2l', vid: FOUNTAIN, name: '', note: '', badge: '', img: 'fountain' });
    }
    /* 2026-09-07：1台の人にだけ、おそうじブラシを ¥1,980→¥1,000 で出す（Eugene指示）。
       2台セットの人は無料ギフトで付くので出さん。ブラシが既に入っとる時も出さん。 */
    var hasF1 = ids.indexOf(FOUNTAIN) >= 0;
    var hasDog = ids.indexOf(FOUNTAIN_DOG) >= 0;
    var hasSet2 = ids.indexOf(FOUNTAIN2) >= 0;
    var hasSet3 = ids.indexOf(FOUNTAIN3) >= 0;
    /* 2026-09-10：入っとる本体で名前を出し分ける（Eugene指示）。
       商品そのものは猫用・犬用で同じ物。名札だけ変える。
       猫と犬の両方が入っとる時は「猫用」を出す（先に売っとる方に寄せる）。 */
    var SUF = (hasDog && !hasF1) ? '（犬用）' : '（猫用）';
    var has1 = hasF1 || hasDog;
    /* 2026-09-12：おそうじブラシは【本体を買った人全員】に無料で付く形に変えた（Eugene指示）。
       無料で付く物を有料で勧めたらおかしいので、ブラシの有料アップセルは出さん。 */
    /* 2026-09-09：1台の人にだけ、毛取りグローブを ¥1,480→¥980 で出す（Eugene指示）。
       2台セットの人は無料ギフトで付くので出さん。既に入っとる時も出さん。 */
    var hasGlove = GLOVES.some(function (v) { return ids.indexOf(v) >= 0; });
    /* グローブは2台以上（と犬）の無料ギフト。1台だけの人には有料で勧める。 */
    var gloveFree = hasSet2 || hasSet3 || hasDog;
    if (has1 && !gloveFree && !hasGlove) {
      list.push({ handle: 'cat-hair-remover-glove', vid: GLOVE_WITH, name: '毛取りグローブ' + SUF, note: '本体と同時なら¥700オフ', badge: 'おトク', img: '', was: true });
    }
    if (!list.length) { UPS.style.display = 'none'; return; }
    Promise.all(list.map(function (o) { return getProduct(o.handle); })).then(function (ps) {
      var html = list.map(function (o, i) {
        var p = ps[i];
        var v = p.variants.filter(function (x) { return x.id === o.vid; })[0] || p.variants[0];
        var name = o.name || (p.title + (v.title && v.title !== 'Default Title' ? ' ' + v.title : ''));
        var M = window.__NYA_UPIMG || {};
        /* 交換フィルターページと同じ写真を使う。無ければ商品の写真に戻す。 */
        var img = (o.img && M[o.img]) ? M[o.img] : px(v.featured_image ? v.featured_image.src : p.featured_image, 120);
        return '<div class="cd-up-card">' +
          '<a href="/products/' + p.handle + '?variant=' + v.id + '" class="cd-up-img" tabindex="-1">' +
            '<img src="' + esc(img) + '" alt="' + esc(name) + '" width="58" height="58" loading="lazy"></a>' +
          '<div class="cd-up-info">' +
            '<a href="/products/' + p.handle + '?variant=' + v.id + '" class="cd-up-name">' + esc(name) +
              (o.badge ? ' <span class="cd-up-badge">' + esc(o.badge) + '</span>' : '') + '</a>' +
            '<div class="cd-up-price">' +
              (o.was && v.compare_at_price > v.price ? '<span class="cd-up-was">' + yen(v.compare_at_price) + '</span> ' : '') + yen(v.price) +
              (o.note ? ' <span class="cd-up-note">' + esc(o.note) + '</span>' : '') + '</div>' +
          '</div>' +
          '<button type="button" class="cd-up-add" data-up-add data-variant="' + v.id + '" aria-label="' + esc(name) + ' を追加">追加</button>' +
        '</div>';
      }).join('');
      UPSL.innerHTML = html;
      UPS.style.display = '';
    }).catch(function () { UPS.style.display = 'none'; });
  }

  /* ── 無料ギフト ────────────────────────────
     ギフトが付く本体が入っとったら、ブラシとグローブを自動で1個ずつ入れる。
     どっちも ¥0 の「無料ギフト」variant なので、店の割引が消えても課金されん。
     本体を消したらギフトも一緒に消す（ギフトだけ残って課金される事故を防ぐ）。 */
  var GIFT_BRUSH = BRUSH_GIFT;   /* 2026-09-11：自動割引依存 → ¥0 variant に変更 */
  var giftBusy = false;

  function gifts(cart) {
    var box = document.getElementById('cd-gifts');
    /* 2026-09-06：おそうじブラシは【2台セットを買った人だけ】の無料ギフトにした（Eugene指示）。
       送料無料はどっちでも付く。だから枠の出し入れは「本体がどれか入っとるか」、
       ブラシの出し入れは「2台セットが入っとるか」で別々に見る。 */
    var hasAny  = cart.items.some(function (i) { return FOUNTAINS.indexOf(i.variant_id) >= 0; });
    var hasSet2 = cart.items.some(function (i) { return i.variant_id === FOUNTAIN2; });
    /* 2026-09-11：犬（ワクア）にもギフトを付ける（Eugene指示）。
       🔴 9/9〜9/10 の犬の注文3件は、この行が無かったせいで
          「特典3つ無料」と書いてあるのに何も入らんかった。 */
    var hasDog  = cart.items.some(function (i) { return i.variant_id === FOUNTAIN_DOG; });
    var hasSet3 = cart.items.some(function (i) { return i.variant_id === FOUNTAIN3; });
    /* 2026-09-12 オファーの形（Eugene決定）
         ・おそうじブラシ … 本体を買った人 全員に無料
         ・毛取りグローブ … 2台セット・3台セット・犬 に無料（1台の人には有料で勧める）
       PDPの「◯台をお選びの方への無料特典」の表記と、ここが必ず一致しとること。 */
    var brushOK = hasAny;
    var gloveOK = hasSet2 || hasSet3 || hasDog;
    var giftOK  = brushOK || gloveOK;
    if (box) {
      box.style.display = hasAny ? '' : 'none';
      box.setAttribute('aria-hidden', hasAny ? 'false' : 'true');
    }
    var bt = document.getElementById('cd-gift-brush');
    if (bt) bt.style.display = brushOK ? '' : 'none';
    var gv = document.getElementById('cd-gift-glove');
    if (gv) gv.style.display = gloveOK ? '' : 'none';
    var nt = document.getElementById('cd-gifts-note');
    var giftN = (brushOK ? 1 : 0) + (gloveOK ? 1 : 0) + 1;   /* ＋送料無料 */
    if (nt) nt.innerHTML = giftOK
      ? '<span style="white-space:nowrap"><b>無料ギフト' + giftN + 'つ</b>が入っています</span>'
      : '<span style="white-space:nowrap"><b>送料無料</b>でお届けします</span>';
    if (giftBusy) return;

    /* ── 無料ギフトの入れ替え（2026-09-09 作り直し）────────────────
       🔴 前は「ブラシを1つ直したら return」やった。ギフトが2つになった今、
          その作りやと2つ目が次の描画まで入らん（描き直しは giftBusy が立っとる間に
          走るので、gifts() が入口で弾かれてしまう）。
          なので「消す物・足す物」を先に全部数えて、まとめて1回で流す。
       2026-09-11：ブラシもグローブも「無料ギフト専用の ¥0 variant」に統一した。
       さらに猫用／犬用で商品を分けたので、どっちの本体が入っとるかで名札を選ぶ。
       猫と犬が両方入っとる時は猫に寄せる（アップセルの名前の出し分けと同じ考え）。 */
    var isDogLane = hasDog && !hasSet2 && !hasSet3;
    var GIFT_DEFS = [
      { all: BRUSHES, gift: isDogLane ? DOG_BRUSH_GIFT : GIFT_BRUSH, ok: brushOK },
      { all: GLOVES,  gift: isDogLane ? DOG_GLOVE_GIFT : GLOVE_GIFT, ok: gloveOK }
    ];
    /* ¥0 のギフト専用 variant。「本体が消えた時に片づける物」はこれだけ。
       客が自分で入れた有料のブラシ／グローブは勝手に消さん。 */
    var GIFT_ONLY = [BRUSH_GIFT, GLOVE_GIFT, DOG_BRUSH_GIFT, DOG_GLOVE_GIFT];
    var removes = [], adds = [], fixes = [];
    GIFT_DEFS.forEach(function (g) {
      var lines = cart.items.filter(function (i) { return g.all.indexOf(i.variant_id) >= 0; });
      var line = lines[0];
      if (g.ok) {
        if (!line) { adds.push(g.gift); }                       /* 無い → 足す */
        else if (line.variant_id !== g.gift) {                  /* 有料 or 逆の名札 → 正しい無料ギフトに差し替え */
          removes.push(line.key); adds.push(g.gift);
        }
        /* 2026-10-11：無料ギフトが2個入る穴を塞ぐ（Eugene「修正して」）。
           カートのページと引き出しが同時に「無いから足す」をやると2個になる。
           無料ギフトは1個だけ＝2個以上なら1個に戻す・2本目の無料ギフトの行は消す。客が自分で入れた有料品は触らん。 */
        else if (line.quantity > 1) { fixes.push(line.key); }
        lines.slice(1).forEach(function (l) {
          if (GIFT_ONLY.indexOf(l.variant_id) >= 0) removes.push(l.key);
        });
      } else {
        var isGift = GIFT_ONLY.indexOf(line && line.variant_id) >= 0 ||
                     !!(line && line.properties && line.properties['_無料ギフト']);
        if (line && isGift) { removes.push(line.key); }         /* ギフト対象の本体が無いのに無料が残っとる → 消す */
      }
    });
    if (!removes.length && !adds.length && !fixes.length) return;

    giftBusy = true;
    var H = { 'Content-Type': 'application/json', 'Accept': 'application/json' };
    var chain = Promise.resolve();
    removes.forEach(function (k) {
      chain = chain.then(function () {
        return fetch('/cart/change.js', { method: 'POST', headers: H,
          body: JSON.stringify({ id: k, quantity: 0 }) });
      });
    });
    fixes.forEach(function (k) {
      chain = chain.then(function () {
        return fetch('/cart/change.js', { method: 'POST', headers: H,
          body: JSON.stringify({ id: k, quantity: 1 }) });
      });
    });
    if (adds.length) {
      chain = chain.then(function () {
        return fetch('/cart/add.js', { method: 'POST', headers: H,
          body: JSON.stringify({ items: adds.map(function (v) {
            return { id: v, quantity: 1, properties: { '_無料ギフト': '1' } };
          }) }) });
      });
    }
    chain.then(function () { return fetch('/cart.js').then(function (r) { return r.json(); }); })
      .then(render).catch(function () {})
      .then(function () { giftBusy = false; });
  }

  /* ── カートを読み直す ───────────────────── */
  var busy = false;
  function refresh() {
    return fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); }).then(render).catch(function () {});
  }
  function change(key, qty) {
    if (busy) return; busy = true;
    var li = ITEMS.querySelector('[data-key="' + key.replace(/"/g, '\\"') + '"]');
    if (li) li.classList.add('is-busy');
    fetch('/cart/change.js', {
      method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: key, quantity: qty })
    }).then(function (r) { return r.json(); }).then(render)
      .catch(function () {}).then(function () { busy = false; });
  }
  function add(vid) {
    return fetch('/cart/add.js', {
      method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: [{ id: Number(vid), quantity: 1 }] })
    }).then(function () { return refresh(); });
  }

  /* ── 割引コード ─────────────────────────── */
  function applyDiscount() {
    var code = (DCI.value || '').trim();
    if (!code) return;
    DCB.disabled = true;
    fetch('/discount/' + encodeURIComponent(code) + '?redirect=/cart.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var ok = (cart.discount_codes || []).some(function (d) {
          return d.applicable && String(d.code).toUpperCase() === code.toUpperCase();
        }) || cart.total_discount > 0;
        DCM.style.display = '';
        DCM.className = 'cd-dc-msg ' + (ok ? 'is-ok' : 'is-err');
        DCM.textContent = ok ? 'コードを適用しました' : 'このコードは使えません';
        if (ok) render(cart);
      })
      .catch(function () {
        DCM.style.display = ''; DCM.className = 'cd-dc-msg is-err';
        DCM.textContent = 'このコードは使えません';
      })
      .then(function () { DCB.disabled = false; });
  }

  /* ── 配線 ───────────────────────────────── */
  function init() {
    D = document.getElementById('CartDrawer'); if (!D) return;
    OV = document.getElementById('cd-overlay');
    ITEMS = document.getElementById('cd-items');
    EMPTY = document.getElementById('cd-empty');
    UPS = document.getElementById('cd-upsell');
    UPSL = document.getElementById('cd-upsell-list');
    SUBL = D.querySelector('[data-subtotal-label]');
    SUBP = D.querySelector('[data-subtotal-price]');
    DCI = document.getElementById('cd-dc-input');
    DCB = document.getElementById('cd-dc-apply');
    DCM = document.getElementById('cd-dc-msg');

    document.addEventListener('click', function (e) {
      var t = e.target;
      if (t.closest && t.closest('#cd-btn-close')) { e.preventDefault(); close(); return; }
      if (t === OV) { close(); return; }
      var q = t.closest && t.closest('[data-qty-change]');
      if (q) { e.preventDefault(); change(q.getAttribute('data-key'), +q.getAttribute('data-qty')); return; }
      var d = t.closest && t.closest('[data-remove]');
      if (d) { e.preventDefault(); change(d.getAttribute('data-key'), 0); return; }
      var u = t.closest && t.closest('[data-up-add]');
      if (u) {
        e.preventDefault();
        var utxt = u.textContent; u.disabled = true; u.textContent = '追加中…';
        add(u.getAttribute('data-variant')).catch(function () {})
          .then(function () { u.disabled = false; u.textContent = utxt; });
        return;
      }
      if (t.closest && t.closest('#cd-dc-apply')) { e.preventDefault(); applyDiscount(); return; }
      /* カートのアイコン・リンクはドロワーを開く */
      var a = t.closest && t.closest('a[href$="/cart"], a[href="/cart"], #cart-icon-bubble');
      if (a && !a.closest('#CartDrawer')) { e.preventDefault(); open(); return; }
    }, false);

    D.querySelector('#CartDrawerForm').addEventListener('submit', function (e) {
      e.preventDefault();
      var b = D.querySelector('.cd-checkout');
      if (b) { b.disabled = true; b.textContent = 'レジへ移動中…'; }
      window.location.href = '/checkout';
    });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') close(); });
    if (DCI) DCI.addEventListener('keydown', function (e) { if (e.key === 'Enter') { e.preventDefault(); applyDiscount(); } });

    /* 「カートに入れる」を押したら、どの作りでも必ずここが開く */
    document.addEventListener('submit', function (e) {
      var f = e.target;
      if (!f || !f.action || f.action.indexOf('/cart/add') < 0) return;
      e.preventDefault(); e.stopPropagation();
      var btn = findAddBtn(f);
      busyOn(btn);
      var fd = new FormData(f); fd.delete('form_type'); fd.delete('utf8');
      fetch('/cart/add.js', { method: 'POST', body: fd, headers: { 'Accept': 'application/json' } })
        .then(function () { open(); })
        .catch(function () {})
        .then(function () { setTimeout(function () { busyOff(btn); }, 250); });
    }, true);

    /* ほかのJSが直接 /cart/add.js を叩いた時も開く */
    var of = window.fetch;
    window.fetch = function (input) {
      var url = typeof input === 'string' ? input : (input && input.url) || '';
      var p = of.apply(this, arguments);
      if (/\/cart\/(add|change|update)(\.js)?/.test(url)) {
        p.then(function () { setTimeout(function () { if (/add/.test(url)) open(); else refresh(); }, 60); });
      }
      return p;
    };
    /* 2026-09-05：/cart に直接来た時。テーマ側のカートと二重に見えるので、
       うちの全画面カートを最初から開いて上にかぶせる。 */
    if (/^\/cart\/?$/.test(location.pathname)) {
      document.documentElement.classList.add('cd-on-cart-page');
      open();
    }
    refresh();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
